// 課金-ADD-START
import React from "react";
import { connect } from "react-redux";

import AuthImage from "@/react-components/AuthImage";
import { modeEnum } from "@/utils/enum";

const OptionServiceCardSection = ({ fields, scMode }) => {
  const src = fields?.image?.value?.src;
  const isShowTip =
    scMode === modeEnum.pageEditing && !fields?.isAvailable?.value;

  return (
    <section className="option-service-card-section-container">
      <div
        className="desc"
        dangerouslySetInnerHTML={{ __html: fields?.detailContent?.value }}
      />
      {src && <AuthImage className="image" src={src} />}
      {isShowTip && (
        <div className="tip">
          本コンポーネントは無効のため非表示となります。
        </div>
      )}
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    scMode: state?.config?.mode,
  };
};

export default connect(mapStateToProps)(OptionServiceCardSection);
// 課金-ADD-END
